export const RolesEnum = {
  roles: 'roles'
} as const;
